import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-page)', paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ padding: '3rem 1.2rem', maxWidth: '900px', margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: '#22c55e',
            cursor: 'pointer',
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          ← Back
        </button>

        <h1 className="heading-1" style={{ marginBottom: '2rem' }}>Privacy Policy</h1>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>Last updated: January 2025</p>

        <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>1. Information We Collect</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We collect information you provide directly to us, such as when you create an account, make an inquiry, 
            fill out a form, or communicate with us. This information may include your name, email address, phone number, 
            and any other information you choose to provide.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>2. How We Use Your Information</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We use the information we collect to provide, maintain, and improve our services, process transactions, 
            send you technical notices and support messages, respond to your comments and questions, and provide customer service.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>3. Information Sharing</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We do not share your personal information with third parties except as described in this policy. 
            We may share information with vendors, consultants, and other service providers who need access to such 
            information to carry out work on our behalf.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>4. Data Security</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We take reasonable measures to help protect information about you from loss, theft, misuse, unauthorized access, 
            disclosure, alteration, and destruction. All data is encrypted during transmission using industry-standard SSL technology.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>5. Your Rights</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            You have the right to access, update, or delete your personal information at any time. You may also opt out of 
            receiving promotional communications from us by following the instructions in those messages.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>6. Contact Us</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            If you have any questions about this Privacy Policy, please contact us at:<br />
            Email: info@ayurmedglobal.com<br />
            Phone: +91-9958096324
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
